import {AutomatGroup} from './automatGroup';
import {AutomatDevice} from './automatDevice';
import {Beacon} from './beacon';
import {AutomatVpos} from './automatVpos';
import {AutomatSim} from './automatSim';
import {Point} from './point';
import {AutomatModem} from './automatModem';
import {AutomatOperator} from './automatOperator';
import {AutomatModel} from './automatModel';
import {Firms} from '../models/firms';

export class AddAutomat {
    constructor() {
    }

    _id?: string;
    name: string;
    modalName: string;
    serial: string;
    external_id?: string;
    maxProductPrice: number;
    operator: AutomatOperator = new AutomatOperator();
    group: AutomatGroup = new AutomatGroup();
    automatModel: AutomatModel = new AutomatModel();
    province: string;
    district: string;
    neighborhood: string;
    description: string;
    device: AutomatDevice = new AutomatDevice();
    vPos: AutomatVpos = new AutomatVpos();
    beacon: Beacon = new Beacon();
    sim: AutomatSim = new AutomatSim();
    modem: AutomatModem = new AutomatModem();
    location: Point = new Point();
    isCoin = false;
    isCard = false;
    isTelemetry = false;
    isPreSalesCard = false;
    isMobil = false;
    isStock = 0;
    firm: Firms = new Firms();
    headStart: 0;
    isEndOfAutomatSale: false;
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/models/addAutomat.ts